import { ref } from 'vue';

// Уникальный идентификатор для активного дропдауна
const activeDropdownId = ref(null);

export function useDropdownManager() {
  // Регистрирует дропдаун как активный и закрывает предыдущий
  const registerActiveDropdown = (id) => {
    if (activeDropdownId.value !== id) {
      activeDropdownId.value = id;
      return true; // Возвращаем true, если это новый активный дропдаун
    }
    return false; // Возвращаем false, если этот дропдаун уже активен
  };

  // Проверяет, является ли дропдаун активным
  const isActiveDropdown = (id) => {
    return activeDropdownId.value === id;
  };

  // Сбрасывает активный дропдаун
  const clearActiveDropdown = (id) => {
    if (activeDropdownId.value === id) {
      activeDropdownId.value = null;
    }
  };

  return {
    registerActiveDropdown,
    isActiveDropdown,
    clearActiveDropdown,
    activeDropdownId
  };
}